<div class="container">
    <div class="header">
        <h6 class="title">{{ 'Port ' + (data.title ? '' : data.port) }}</h6>
        <div class="header-sub-title" *ngIf="data.title">{{ data.title }}</div>
    </div>
    <div class="main">
        <div class="block name">
            <div class="sub-title">
                {{ 'system-settings.port.name' | translate }}
            </div>
            <app-system-setting-input
                [name]="COMM_NAME"
                label="system-settings.port.label.name"
                [value]="data.commName"
                [maxLength]="COMM_NAME_MAX"
                [showLenCounter]="true"
                (onInputChange)="onInputChange($event)"
                [inputErrorMessage]="validationErrors?.commName?.message"
                [showErrorMessage]="true">
            </app-system-setting-input>
        </div>
        <div class="ip-address" [class.hidden]="data.commType !== LAN">
            <div class="line">
                <div class="sub-title">
                    {{ 'system-settings.external-communication.table.header.ip-line' | translate }}
                </div>
                <app-system-setting-input
                    [name]="LINE_IP_ADDRESS"
                    label="system-settings.ops.dialog.input-placeholder.a-line-ip"
                    [value]="data.LineIp"
                    (onInputChange)="onInputChange($event)"
                    [inputErrorMessage]="validationErrors?.LineIp?.message"
                    [showErrorMessage]="true"
                    [maxLength]="15">
                </app-system-setting-input>
            </div>
        </div>
    </div>
    <div class="footer">
        <div class="button-container">
            <button class="text-button" (click)="close()">
                {{ 'dlg.cancel' | translate }}
            </button>
            <app-button
                [disable]="disabledSaveButton()"
                text="system-settings.port.button.save"
                customFontFamily="NotoSans-SemiBold"
                size="small"
                customFontSize="14px"
                (onClick)="save()"></app-button>
        </div>
    </div>
</div>
